import Dinero from "dinero.js";

/**
 * Money helpers built on dinero.js. Storage is always integer cents; display
 * strings are produced via Dinero so rounding / locale stays consistent.
 */

export function centsToDinero(cents, currency = "USD") {
  const amount = Number.isFinite(Number(cents)) ? Math.round(Number(cents)) : 0;
  return Dinero({ amount, currency });
}

/**
 * Format integer cents as a plain "00.00" string (no currency symbol).
 * Use the symbol in the surrounding UI per the Figma spec.
 */
export function formatCents(cents, currency = "USD") {
  return centsToDinero(cents, currency).toFormat("0,0.00");
}

/**
 * Convert an integer-cents value to the string a text input should display
 * while the user is editing (e.g. 1965 -> "19.65"). Returns "" for null/blank.
 */
export function centsToInputValue(cents) {
  if (cents === null || cents === undefined || cents === "") return "";
  const num = Number(cents);
  if (!Number.isFinite(num)) return "";
  return (Math.round(num) / 100).toFixed(2);
}

/**
 * Parse a free-form dollars/cents string from a text input into integer cents.
 * Returns `null` for an empty / unparseable value so callers can distinguish
 * "user cleared the field" from a real zero.
 */
export function inputValueToCents(value) {
  if (value === null || value === undefined) return null;
  const cleaned = String(value).replace(/[^0-9.\-]/g, "");
  if (cleaned === "" || cleaned === "." || cleaned === "-") return null;
  const num = Number(cleaned);
  if (!Number.isFinite(num)) return null;
  return Math.round(num * 100);
}

/**
 * Display helper for price values that may arrive as a number or a
 * pre-formatted string. A number is rendered to 2dp with a leading "$"; a
 * string that already starts with "$" is passed through, otherwise "$" is
 * prepended. Returns "" for null/undefined/blank so callers can render nothing.
 */
export function formatCurrency(value) {
  if (value === undefined || value === null || value === "") return "";
  if (typeof value === "number") return `$${value.toFixed(2)}`;
  return value.toString().startsWith("$") ? value : `$${value}`;
}
